import { render, staticRenderFns } from "./DetailAma.vue?vue&type=template&id=11371aca&scoped=true&"
import script from "./DetailAma.vue?vue&type=script&lang=js&"
export * from "./DetailAma.vue?vue&type=script&lang=js&"
import style0 from "./DetailAma.vue?vue&type=style&index=0&id=11371aca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11371aca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2065084294/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11371aca')) {
      api.createRecord('11371aca', component.options)
    } else {
      api.reload('11371aca', component.options)
    }
    module.hot.accept("./DetailAma.vue?vue&type=template&id=11371aca&scoped=true&", function () {
      api.rerender('11371aca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ama/DetailAma.vue"
export default component.exports